export default __webpack_public_path__ + "static/media/edit.25cd580b.svg";